module.exports = __webpack_public_path__ + "static/media/send.7cf0de04.png";